export default __webpack_public_path__ + "static/media/banner1.ef1905af.gif";